import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

export default class InventoryList extends Component{
  render() {
    return(
      <div className="card p-0">
        {this.props.inventories.length ?
          <table className="table table-striped table-bordered datatable mb-0">
            <thead>
              <tr>
                <th>Item</th>
                <th>Grade</th>
                <th>Total Qty</th>
                <th>Count</th>
              </tr>
            </thead>
            <tbody>
              {this.props.inventories.map((i,idx) => {
                let url = ''
                if (this.props.selectedPlant) url += `&plant=${this.props.selectedPlant}`
                if (this.props.selectedLot) url += `&lot=${this.props.selectedLot}`
                if (this.props.selectedStation) url += `&station=${this.props.selectedStation}`
                if (i.grade !== '') url += `&grade=${i.grade.id}`
                return (
                  <tr key={idx}>
                    <td>
                      <NavLink to={`/reports/inventory?item=${i.item_id}${url}`}>
                        {i.item}
                      </NavLink>
                    </td>
                    <td>{i.grade ? i.grade.grade : '-'}</td>
                    <td>
                      <span>{(i.total_amount).toFixed(2)}</span>
                      <span className="badge badge-pill badge-info ml-025">
                        {i.measure_unit? i.measure_unit : 'kg'}
                      </span>
                    </td>
                    <td>{i.count}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        :
          <div className="shipment-no-items mb-0">
            No results for given filters
          </div>
        }
      </div>
    )
  }
}
